module.exports = __webpack_public_path__ + "072878bc70d214fba1acda6ac3fcd23d.svg";